import { render, staticRenderFns } from "./FixedIncomeProducts.vue?vue&type=template&id=f9aaf1bc&scoped=true"
import script from "./FixedIncomeProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./FixedIncomeProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FixedIncomeProducts.vue?vue&type=style&index=0&id=f9aaf1bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9aaf1bc",
  null
  
)

export default component.exports